import { useState, useEffect, useRef } from "preact/hooks";
import { initDb } from "../../helpers/initDb";

const LoadPreviousData = ({ onSetPrevData, onConfirmPrevData }) => {
  const [prevDataList, setPrevDataList] = useState([]);
  const idb = useRef();

  useEffect(() => {
    idb.current = initDb();

    idb.current.then((db) =>
      db.getAllKeys("tableData").then((keys) => {

        const prevDataPromised = keys.map(async key => {
          const metadata = await db.get("metadata", key);
        
          return { timestamp: key, metadata }; // ehh  allright
        });
        
        Promise.all(prevDataPromised).then(prevData => setPrevDataList(prevData) )
      }
      )
    );
  }, []);

  // move to state machine too? can it connect to idb?
  const getDataFromIdb = async (key) => {
    console.log("getData from idb");
    const currentIdb = await idb.current; // ehhh currentIdbmm here?

    const tableData = await currentIdb.get("tableData", key);
    const bins = await currentIdb.get("bins", key);
    const metadata = await currentIdb.get("metadata", key);

    console.log({tableData}, {bins}, {metadata});

    onSetPrevData({bins, tableData, metadata });
  };

  const removeDataFromIdb = async (key) => {
    const currentIdb = await idb.current;

    await currentIdb.delete("tableData", key);
    await currentIdb.delete("bins", key);
    await currentIdb.delete("metadata", key);

  };

  return (
    <div class="define-data-card">
      <h2 class="h2">Load previous data</h2>
      <p>
        Load data from one of your prior visits, which is saved per hour. This
        data is saved locally in your browser's storage.
      </p>
      <div class="mt-4">
        {prevDataList.length ? (
          [...prevDataList].reverse().map(({timestamp, metadata }) => (
            <div class="btn bg-blue-500 text-white hover:bg-blue-700 hover:text-gray-300 flex w-full md:w-1/4 mb-2">
              <button
                class="text-left font-bold block my-2 w-11/12"
                onClick={() => getDataFromIdb(timestamp)}
              >
                {new Date(timestamp).toLocaleString()} : {metadata.binsTitle}
              </button>
              <button
                class="hover:text-red-400 w-1/12"
                title="Remove this data from local storage"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  class="h-6 w-6"
                  stroke="currentColor"
                  onClick={() => removeDataFromIdb(timestamp)}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </button>
            </div>
          ))
        ) : (
          <div class="text-gray-200 py-2 px-4 rounded shadow-md bg-orange-400 font-bold w-1/2">
            No old data stored...
          </div>
            
        )}
      </div>
      <div class="flex justify-end pt-2">
        <button
          class="btn btn-blue mt-4"
          onClick={onConfirmPrevData}
        >
          Confirm
        </button>
      </div>
    </div>
  );
};

export { LoadPreviousData };
